import styled from 'styled-components';

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-base);
  margin-bottom: var(--spacing-large);
`;

export const Fieldset = styled.fieldset`
  all: unset;
  display: block;
  width: 100%;
  padding-bottom: var(--spacing-base);
  margin-bottom: var(--spacing-base);
  border-bottom: 2px solid var(--grey-100);
`;

export const Legend = styled.legend`
  margin-bottom: var(--spacing-base);
  font-size: var(--font-size-text-md);
  font-weight: var(--font-weight-semibold);
  color: var(--black);
`;

/* Amount radio pills */
export const AmountOptions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: var(--spacing-small);
`;

export const AmountOption = styled.label<{ $isSelected: boolean }>`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: var(--spacing-xsmall) var(--spacing-large);
  background: ${props => (props.$isSelected ? 'var(--brand-600)' : 'var(--grey-100)')};
  border: 1px solid ${props => (props.$isSelected ? 'var(--brand-600)' : 'var(--grey-200)')};
  border-radius: var(--radius-fullyrounded);
  font-size: var(--font-size-text-md);
  font-weight: var(--font-weight-medium);
  color: ${props => (props.$isSelected ? 'var(--white)' : 'var(--black)')};
  transition: background .15s ease, border-color .15s ease, color .15s ease;
  user-select: none;

  input {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
  }
`;

/* Quantity stepper */
export const QuantityStepper = styled.div`
  display: inline-flex;
  align-items: center;
  border: 1px solid var(--grey-300);
  border-radius: var(--radius-base);
  height: 44px;
  width: 100px;
`;

export const StepperButton = styled.button`
  all: unset;
  cursor: pointer;
  width: 30px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--grey-500);

  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }

  &:hover:not(:disabled) {
    color: var(--black);
  }
`;

export const QuantityInput = styled.input`
  all: unset;
  width: 40px;
  text-align: center;
  font-size: var(--font-size-text-md);
  font-weight: var(--font-weight-medium);
  color: var(--black);
  -moz-appearance: textfield;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

/* Add-to-cart button — matches checkout Button pattern */
export const AddToCartButton = styled.button`
  width: 100%;
  height: 44px;
  border: 1px solid var(--brand-500);
  border-radius: var(--radius-large);
  background: var(--brand-500);
  color: var(--black);
  font-size: var(--font-size-text-md);
  font-weight: var(--font-weight-semibold);
  line-height: 24px;
  box-shadow: var(--shadow-xs);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background .15s ease, border-color .15s ease;

  &:hover:not(:disabled) {
    background: var(--brand-600);
    box-shadow: var(--shadow-focus);
  }

  &:focus-visible {
    outline: 0;
    box-shadow: var(--shadow-focus);
    border-color: var(--brand-600);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
